var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { connect } from 'react-redux';
import { Button, ButtonContainer, ModalFooter } from '@emburse/ui-core';
import { CardTransactionRow } from '@ReactComponents/CardTransactionRow';
import { MultiSelectList } from '@ReactComponents/MultiSelectList';
import { WizardPanel } from '@ReactComponents/Wizard/Wizard';
import { SetDiffsToApply } from '@Actions/index';
import { CloseModal } from '@Actions/modalActions';
import { store } from '@ReactStore/store';
import { BulkUploadApiService as bulkUploadApiService } from '@ClientApi/bulkUpload';
// Styles
import * as style from './ManualUploadCardProgramSummary.styl';
function renderCardTransactionRowForDiff(diff) {
    return (_jsx(CardTransactionRow, { avatarUrl: diff.cardHolder && diff.cardHolder.avatar_url, cardHolderName: diff.cardHolder && diff.cardHolder.name, transactionId: diff.id, amount: diff.amount, merchant: diff.vendor, dateMilliseconds: diff.dateMilliseconds }));
}
export class ManualUploadCardProgramSummary extends WizardPanel {
    constructor(props) {
        super(props);
    }
    applyDiffs() {
        return __awaiter(this, void 0, void 0, function* () {
            const me = this;
            const diffs = this.props.allDiffs;
            const savedFile = this.props.savedFile;
            const fileType = this.props.fileType;
            const account = this.props.cardProgram;
            const accountId = (account && account.id) || null;
            try {
                const res = yield bulkUploadApiService.applyCardStatementDiffs(diffs, savedFile, fileType, accountId);
                if (res.message !== 'Success!') {
                    me.props.onFailure(res.message, true);
                    me.props.closeModal();
                }
                else {
                    me.props.onSuccess();
                    me.props.closeModal();
                }
            }
            catch (err) {
                me.props.onFailure();
                me.props.closeModal();
            }
        });
    }
    componentDidMount() {
        const { addCardDiffs, hasReviewedNewCards } = this.props;
        if (addCardDiffs.length > 0 && !hasReviewedNewCards) {
            return this.props.changePanel('card_mapping');
        }
    }
    render() {
        const { addCardDiffs, addTransactionDiffs } = this.props;
        const usersById = store.getState().users.usersById;
        const transactionsWithNewCardHolderInfo = addTransactionDiffs.map(function (txDiff) {
            if (txDiff.cardHolder) {
                // if pre-populated with an existing cardholder, we're done!
                return txDiff;
            }
            const card = addCardDiffs.find(function (cardDiff) {
                return txDiff.accountId === cardDiff.id;
            });
            return Object.assign(Object.assign({}, txDiff), { cardHolder: card ? usersById[card.userId] : null });
        });
        const transactionDiffsToUpload = addTransactionDiffs.filter((txDiff) => !txDiff.skip);
        const numberToUpload = transactionDiffsToUpload.length;
        const { whitelabelConfiguration } = window;
        const manualStatementUploadLink = whitelabelConfiguration.supportLinks.manualStatementUpload;
        return (_jsxs("div", Object.assign({ className: style.global }, { children: [_jsxs("div", { children: [_jsx("p", { children: "Please select which transactions you wish to upload." }), _jsx("div", { children: _jsx(MultiSelectList, { headerText: `${numberToUpload} Transactions`, items: transactionsWithNewCardHolderInfo, getItemSelected: (diff) => !diff.skip, getItemComponent: renderCardTransactionRowForDiff, onChange: (changes) => this.props.setDiffsToApply(changes) }) }), _jsx("div", { children: _jsx("a", Object.assign({ target: "_blank", rel: "noopener noreferrer", href: manualStatementUploadLink }, { children: "This transaction info does not look correct" })) })] }), _jsx(ModalFooter, { children: _jsxs(ButtonContainer, Object.assign({ alignButtons: "right" }, { children: [_jsx(Button, Object.assign({ variant: "outlined", onClick: this.props.goBack }, { children: "Back" })), _jsxs(Button, Object.assign({ primary: true, onClick: () => this.applyDiffs() }, { children: ["Import ", numberToUpload, " Transactions"] }))] })) })] })));
    }
}
// Connected Component
const mapStateToProps = (state, parentProps) => {
    const s = state.cardStatementUpload;
    const users = state.users.users;
    return Object.assign(Object.assign({}, parentProps), { users, error: s.error, allDiffs: s.allDiffs, addCardDiffs: s.addCardDiffs, addTransactionDiffs: s.addTransactionDiffs, errorDiffs: s.errorDiffs, hasReviewedNewCards: s.reviewedCardHolders, hasReviewedDuplicates: s.reviewedDuplicates, savedFile: s.savedFile, fileType: s.fileType });
};
const mapDispatchToProps = (dispatch) => ({
    closeModal: () => {
        dispatch(new CloseModal());
    },
    setDiffsToApply: (diffs) => dispatch(new SetDiffsToApply(diffs))
});
export const ConnectedManualUploadCardProgramSummary = connect(mapStateToProps, mapDispatchToProps)(ManualUploadCardProgramSummary);
